<template>
    <transition name="dialogfade">
        <k-dialog v-if="showDialog"
            class="edit-condition-dialog add-condition-dialog"
            :title="dialogTitle"
            @close="closeDialog">
            <div class="edit-condition__wrapper">
                <section class="edit-condition__section-detail">
                    <div class="select-condition__wrapper">
                        <h2 class="section--title">Condition <span><i>(required)</i></span></h2>
                        <div class="select-condition__dropdown">
                        <k-dropdown :data-items="filteredConditionList"         
                            :text-field="'title'"
                            :data-item-key="'id'"
                            :value="selectedConditionValue"
                            :filterable="true"
                            @filterchange="onConditionFilterChange"
                            @change="onConditionSelected"></k-dropdown>
                        </div>
                    </div>

                    <div class="condition-detail__wrapper">
                        <h2 class="section--title">Condition Detail</h2>
                        <label>
                            Prior To
                            <k-dropdown @change="onPriorToSelected" :data-items="priorToSelects" v-model="selectedPriorToValue"></k-dropdown>
                        </label>
                        <label>
                            <span class="external__label-row">Condition Description <k-button v-on:click="populateInternal" :disabled="!newCondition.externalDescription || newCondition.externalDescription === newCondition.internalDescription" class="copy-external__btn">Copy to UW Notes</k-button></span>
                            <k-textarea @input="checkForConditionChanges" :rows="7" v-model="newCondition.externalDescription"></k-textarea>
                        </label>
                        <label>
                            <span class="external__label-row">Internal UW Notes <k-button v-on:click="populateExternal" :disabled="!newCondition.internalDescription || newCondition.internalDescription === newCondition.externalDescription" class="copy-external__btn">Copy to Description</k-button></span>
                            <k-textarea @input="checkForConditionChanges" :rows="7" v-model="newCondition.internalDescription"></k-textarea>
                        </label>
                    </div>
                </section>
                <section class="edit-condition__section-tracking">
                    <h2 class="section--title">Tracking Status</h2>
                    <div v-for="status in trackingStatus" :key="status.status" v-bind:class="['tracking-checkbox__container']">
                        <k-checkbox @change="checkForConditionChanges" v-model="status.isChecked">
                            <label :for="status.status" class="tracking-status__label">{{ status.status }}</label>
                        </k-checkbox>
                    </div>
                </section>
            </div>
            <k-dialog-actions>
                <k-button v-bind:class="['dialog__btn dialog__btn--save', { 'dialog__btn--save-active': !saveConditionBtnDisabled }]" v-on:click="saveCondition">{{ saveConditionBtnDisabled ? 'Close' : 'Save and Close' }}</k-button>
            </k-dialog-actions>

            <transition name="dialogfade">
                <k-dialog v-if="showConfirmCloseDialog"
                class="edit-condition-dialog confirm-junk-dialog"
                :title="'You have unsaved changes'"
                @close="toggleConfirmCloseDialog">
                    <p class="confirm-junk--msg">Are you sure you would like to cancel your changes?</p>
                    <k-dialog-actions>
                        <k-button class="dialog__btn dialog__btn--close" v-on:click="toggleConfirmCloseDialog">No</k-button>
                        <k-button class="dialog__btn dialog__btn--save" v-on:click="confirmCloseDialog">Yes</k-button>
                    </k-dialog-actions>
                </k-dialog>
            </transition>

            <div class="conditions__loader-container" v-if="isLoading">
                <loader :size="'large'" :type="'infinite-spinner'"></loader>
            </div>
        </k-dialog>
    </transition>
</template>

<script>
    import auth from '../authConfig.js';
    import apiService from '../api/api.service.js';

    import { Dialog, DialogActionsBar, Window } from '@progress/kendo-vue-dialogs';
    import { Input, TextArea, Checkbox } from "@progress/kendo-vue-inputs";
    import { Button } from '@progress/kendo-vue-buttons';
    import { DropDownList } from '@progress/kendo-vue-dropdowns';
    import { Loader } from "@progress/kendo-vue-indicators";
    import { filterBy } from '@progress/kendo-data-query';

    import isEqual from 'lodash.isequal';

    export default {
        props: ['duplicatedCondition', 'loanId', 'showDialog'],
        emits: ['conditionadded', 'dialogclosed', 'requesterror'],
        data() {
            return {
                conditionList: [],
                conditionUpdated: false,
                defaultConditionValue: { title: 'Select Condition', id: '0' },
                defaultPriorToValue: 'Select Option',
                errorMsg: '',
                errorTitle: '',
                filteredConditionList: [],
                isLoading: false,
                newCondition: {
                    ConditionType: 'Underwriting',
                    Title: '',
                    internalDescription: '',
                    externalDescription: '',
                    priorTo: '',
                    id: ''
                },
                newConditionId: '',
                priorToSelects: ['Approval', 'Closing', 'Docs', 'Purchase'],
                saveConditionBtnDisabled: true,
                selectedConditionValue: { title: 'Select Condition', id: '0' },
                showConfirmCloseDialog: false,
                selectedPriorToValue: 'Select Option',
                trackingStatus: [],
                trackingStatusModel: [
                    {
                        status: 'Requested',
                        isChecked: false
                    },
                    {
                        status: 'Re-requested',
                        isChecked: false
                    },
                    {
                        status: 'Fulfilled',
                        isChecked: false
                    },
                    {
                        status: 'Reviewed',
                        isChecked: false
                    },
                    {
                        status: 'Rejected',
                        isChecked: false
                    },
                    {
                        status: 'Cleared',
                        isChecked: false
                    },
                    {
                        status: 'Waived',
                        isChecked: false
                    },
                    {
                        status: 'Removed By Swift',
                        isChecked: false
                    }
                ],
                trackingUpdated: false,
                uneditedCondition: {},
                uneditedTrackingStatus: []
            }
        },
        computed: {
            dialogTitle() {
                return this.duplicatedCondition ? 'Duplicate Condition' : 'Add Condition';
            }
        },
        mounted() {
        },
        watch: {
            showDialog(val) {
                if (val) {
                    this.getConditionsToAdd();
                    this.processSelectedCondition();

                    this.newCondition = {
                        ConditionType: 'Underwriting',
                        Title: '',
                        internalDescription: '',
                        externalDescription: '',
                        priorTo: '',
                        id: ''
                    }

                    if (this.duplicatedCondition) {
                        this.onConditionSelected({ value: this.duplicatedCondition });
                    }
                    
                } else {
                    this.conditionUpdated = false;
                    this.trackingUpdated = false;
                    this.saveConditionBtnDisabled = true;
                    this.isLoading = false;

                    this.uneditedCondition = {},

                    this.selectedConditionValue = Object.assign({}, this.defaultConditionValue);
                    this.selectedPriorToValue = this.defaultPriorToValue;
                }
            },
            '$store.state.errorAlert'(val) {
                if (val) {
                    this.isLoading = false;
                }
            }
        },
        methods: {
            async addCondition() {
                this.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                if (!this.trackingUpdated) {
                    this.newCondition.bySwift = false;

                    await this.$store.dispatch('addCondition', this.newCondition);
                } else {
                    let request = {
                        bySwift: false,
                        condition: this.newCondition,
                        conditionTracking: this.trackingStatus
                    }

                    await this.$store.dispatch('addConditionAndTracking', request);
                }

                this.$emit('conditionadded', this.newCondition.Title);
            },
            checkForConditionChanges() {
                if (!isEqual(this.newCondition, this.uneditedCondition)) {
                    this.conditionUpdated = true;
                } else {
                    this.conditionUpdated = false;
                }

                if (!isEqual(this.trackingStatus, this.uneditedTrackingStatus)) {
                    this.trackingUpdated = true;
                } else {
                    this.trackingUpdated = false;
                }

                if (this.newCondition.id) {
                    return this.saveConditionBtnDisabled = false;
                }

                this.saveConditionBtnDisabled = true;
            },
            closeDialog() {
                if (!this.saveConditionBtnDisabled) return this.toggleConfirmCloseDialog();

                this.$emit('dialogclosed');
            },
            confirmCloseDialog() {
                this.showConfirmCloseDialog = !this.showConfirmCloseDialog;

                this.$emit('dialogclosed');
            },
            async getConditionsToAdd() {
                this.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                apiService.GetConditionTemplates(tokenResponse.accessToken)
                    .then(res => {
                        this.isLoading = false,

                        this.conditionList = res.data.data;
                        this.conditionList.unshift(this.defaultConditionValue);

                        this.filteredConditionList = JSON.parse(JSON.stringify(this.conditionList));
                    }).catch(error => {
                        this.isLoading = false;
                        this.closeDialog();

                        this.errorTitle = 'Failed to Fetch Conditions';

                        if(error?.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.$emit('requesterror', this.errorTitle, this.errorMsg);
                    });
            },
            onConditionFilterChange(evt) {
                this.filteredConditionList = filterBy(this.conditionList, evt.filter);
            },
            onConditionSelected(evt) {
                this.selectedConditionValue = evt.value;

                if (this.selectedConditionValue.title === 'Select Condition') {
                    this.newCondition.priorTo = '';
                    this.selectedPriorToValue = 'Select Option';
                    this.newCondition.Title = '';
                    this.newCondition.internalDescription = '';
                    this.newCondition.externalDescription = '';
                    this.newCondition.id = '';
                    
                    return this.checkForConditionChanges();
                }
                
                this.newCondition.id = this.selectedConditionValue.id;
                this.newCondition.priorTo = this.selectedConditionValue.priorTo;
                this.newCondition.Title = this.selectedConditionValue.title;
                this.newCondition.internalDescription = this.selectedConditionValue.internalDescription ? this.selectedConditionValue.internalDescription : '';
                this.newCondition.externalDescription = this.selectedConditionValue.externalDescription ? this.selectedConditionValue.externalDescription: '';
                this.newCondition.printDefinitions = this.selectedConditionValue.printDefinitions ? this.selectedConditionValue.printDefinitions : [];
                this.selectedPriorToValue = this.selectedConditionValue.priorTo;

                this.checkForConditionChanges();
            },
            onPriorToSelected(evt) {
                this.newCondition.priorTo = this.selectedPriorToValue;
                this.checkForConditionChanges();
            },
            populateExternal() {
                this.newCondition.externalDescription = this.newCondition.internalDescription;
                this.checkForConditionChanges();
            },
            populateInternal() {
                this.newCondition.internalDescription = this.newCondition.externalDescription;
                this.checkForConditionChanges();
            },
            processSelectedCondition() {
                this.uneditedCondition = Object.assign({}, this.newCondition);

                this.trackingStatus = JSON.parse(JSON.stringify(this.trackingStatusModel));

                this.uneditedTrackingStatus = JSON.parse(JSON.stringify(this.trackingStatus));

                //this.trackingStatus.find(track => track.status === 'Requested').isChecked = true;
            },
            async saveCondition() {
                if (this.saveConditionBtnDisabled) return this.closeDialog();
                
                if (this.conditionUpdated) {
                    return await this.addCondition();
                }
            },
            toggleConfirmCloseDialog() {
                this.showConfirmCloseDialog = !this.showConfirmCloseDialog;
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'k-textarea': TextArea,
            'k-button': Button,
            'k-dropdown': DropDownList,
            'k-checkbox': Checkbox,
            'loader': Loader
        }
    }
</script>

<style>
    @import '/src/assets/css/editConditionDialog.css';
    @import '/src/assets/css/addConditionDialog.css';
</style>
